var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (autofocus, placeholder) {
buf.push("<i class=\"icon-search\"></i><input type=\"text\"" + (jade.attr("placeholder", placeholder, true, true)) + (jade.attr("autofocus", autofocus, true, true)) + " class=\"bordered-input js-typeahead-input\"><div class=\"typeahead-loading-indicator\"><div class=\"loading-spinner-small\"></div></div>");}.call(this,"autofocus" in locals_for_with?locals_for_with.autofocus:typeof autofocus!=="undefined"?autofocus:undefined,"placeholder" in locals_for_with?locals_for_with.placeholder:typeof placeholder!=="undefined"?placeholder:undefined));;return buf.join("");
};
module.exports = template;